import { buildModelManager } from "../builder.js";
const DefaultChatMessageV2Selection = {
  __typename: true,
  id: true,
  content: { markdown: true, truncatedHTML: true },
  conversationId: true,
  createdAt: true,
  messageId: true,
  modelResponseId: true,
  modelUsed: true,
  processingTimeMs: true,
  role: true,
  timestamp: true,
  updatedAt: true
};
const modelApiIdentifier = "chatMessageV2";
const pluralModelApiIdentifier = "chatMessageV2s";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultChatMessageV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultChatMessageV2Selection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultChatMessageV2Selection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultChatMessageV2Selection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultChatMessageV2Selection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultChatMessageV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultChatMessageV2Selection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByMessageId",
    findByField: "messageId",
    findByVariableName: "messageId",
    modelApiIdentifier,
    defaultSelection: DefaultChatMessageV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByMessageId",
    findByField: "messageId",
    findByVariableName: "messageId",
    modelApiIdentifier,
    defaultSelection: DefaultChatMessageV2Selection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createChatMessageV2",
    operationReturnType: "CreateChatMessageV2",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      chatMessageV2: { required: false, type: "CreateChatMessageV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultChatMessageV2Selection
  },
  {
    type: "action",
    operationName: "bulkCreateChatMessageV2s",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateChatMessageV2sInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultChatMessageV2Selection
  },
  {
    type: "action",
    operationName: "updateChatMessageV2",
    operationReturnType: "UpdateChatMessageV2",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      chatMessageV2: { required: false, type: "UpdateChatMessageV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultChatMessageV2Selection
  },
  {
    type: "action",
    operationName: "bulkUpdateChatMessageV2s",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateChatMessageV2sInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultChatMessageV2Selection
  },
  {
    type: "action",
    operationName: "deleteChatMessageV2",
    operationReturnType: "DeleteChatMessageV2",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteChatMessageV2s",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertChatMessageV2",
    operationReturnType: "UpsertChatMessageV2",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      chatMessageV2: { required: false, type: "UpsertChatMessageV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateChatMessageV2Result": { hasReturnType: false },
      "... on UpdateChatMessageV2Result": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultChatMessageV2Selection
  },
  {
    type: "action",
    operationName: "bulkUpsertChatMessageV2s",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertChatMessageV2sInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultChatMessageV2Selection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "chatMessageV2GellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ChatMessageV2Manager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultChatMessageV2Selection,
  operations
);
export {
  ChatMessageV2Manager,
  DefaultChatMessageV2Selection
};
//# sourceMappingURL=ChatMessageV2.js.map
